import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { IBreadcrumbsAndMenu, ITab, IMenuOption } from "../../../types/global";
import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import { Box, Typography } from "@mui/material";
import CustomizedButton from "../../../components/Custom/CustomizedButton";
import CustomizedTab from "../../../components/Custom/CustomizedTab";
import CustomerDepositTable from "../../../components/Table/Sales/CustomerDeposit";
import CustomizedMenuOptions from "../../../components/Custom/CustomizedMenuOptions";
import ExporterSalesModal from "../../../components/UI/Modal/ExporterSalesModal";
import { useModal } from "../../../hooks/use-modal";
import { SalesExportType } from "../../../generated/sales";

const CustomerDeposit = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const isFilter = searchParams.get("filter");

  const { modal, openModalHandler, closeModalHandler } = useModal();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("sales.index"),
      to: "/sales",
    },
    {
      name: t("sales.customer_deposit.index"),
    },
  ];

  const tabs: ITab[] = [
    {
      label: t("status.all"),
      path: `${pathname}`,
    },
    {
      label: t("status.draft"),
      path: `${pathname}?filter=draft`,
    },
    {
      label: t("status.wait_deduction"),
      path: `${pathname}?filter=wait_deduction`,
    },
    {
      label: t("status.partially_deduction"),
      path: `${pathname}?filter=partially_deduction`,
    },
    {
      label: t("status.finished"),
      path: `${pathname}?filter=finished`,
    },
    {
      label: t("status.cancelled"),
      path: `${pathname}?filter=cancelled`,
    },
  ];

  const options: IMenuOption[] = [
    {
      value: t("sales.export"),
    },
  ];

  const currentTab = pathname + (isFilter ? `?filter=${isFilter}` : "");

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box sx={{ display: "flex", justifyContent: "space-between", my: 3 }}>
        <Typography variant="h5">
          {t("sales.customer_deposit.index")}
        </Typography>
        <Box display="flex" gap={1}>
          <CustomizedButton
            title={`${t("button.create")}${t("sales.customer_deposit.index")}`}
            variant="contained"
            onClick={() => navigate(`${pathname}/add`)}
            addIcon
          />
          <CustomizedMenuOptions
            isIcon
            options={options}
            onSelect={(e) => {
              const value = e.target as HTMLElement;
              switch (value.innerText) {
                case `${t("sales.export")}`:
                  openModalHandler();
                  break;
                default:
              }
            }}
          />
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <CustomizedTab tabs={tabs} currentTab={currentTab} divider table />
      </Box>
      <CustomerDepositTable isFilter={isFilter} />{" "}
      <ExporterSalesModal
        open={modal}
        closeModalHandler={closeModalHandler}
        documentType={SalesExportType.CustomerDeposit}
      />
    </>
  );
};

export default CustomerDeposit;
